<template>
  <div class="skip-links">
    <a href="#nav" class="skip-links__link">Skip to nav</a>
    <a href="#main" class="skip-links__link">Skip to content</a>
    <a href="#footer" class="skip-links__link">Skip to footer</a>
  </div>

  <AppHeader
    @logout="$emit('logout')"
    :routes="headerRoutes || portalRoutesAlternate"
    class="app-header"
  >
    <template v-if="headerRoutes" #navigation>
      <DesktopHeaderNavigation class="header-navigation__desktop" :routes="headerRoutes" />
      <MobileHeaderNavigation class="header-navigation__tablet" :routes="headerRoutes" />
    </template>
  </AppHeader>

  <main class="page-content" id="main">
    <router-view v-if="!isShowErrorScreen" @set-navigation="setHeaderNavigation" />
    <ErrorScreen v-else />
  </main>

  <AppTerms />
  <AppArticle />
  <AppFooter id="footer" />
  <ServiceErrorWindow
    :is-show="store.isShowInternalServerErrorPopup"
    @close="store.isShowInternalServerErrorPopup = false"
  />
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';

  import ErrorScreen from '@/components/ErrorScreen.vue';
  import AppHeader from '@/components/header/AppHeader.vue';
  import DesktopHeaderNavigation from '@/components/header/components/DesktopHeaderNavigation';
  import MobileHeaderNavigation from '@/components/header/components/MobileHeaderNavigation';
  import AppArticle from '@/components/layout-components/AppArticle.vue';
  import AppFooter from '@/components/layout-components/AppFooter.vue';
  import AppTerms from '@/components/layout-components/AppTerms.vue';
  import ServiceErrorWindow from '@/components/ServiceErrorWindow.vue';
  import { portalRoutesAlternate } from '@/constants/headerRoutes';
  import { useStore } from '@/stores';
  import { NavigationLink } from '@/types/interfaces';

  defineEmits<{
    (n: 'logout'): void
  }>();

  const store = useStore();
  const headerRoutes = ref<NavigationLink[] | null>(null);

  const setHeaderNavigation = (links: NavigationLink[] | null) => {
    headerRoutes.value = links;
  };

  const isShowErrorScreen = computed<boolean>(() => store.isShowErrorScreen);

  defineExpose({
    headerRoutes,
  });
</script>

<style scoped lang="scss">
  .app-header {
    @include md {
      position: fixed;
      top: 0px;
      z-index: 100;
    }
  }
  .page-content {
    @include md {
      padding-top: 100px;
    }
    flex: 1 0;
    width: 100%;
    max-width: $max-content-width;
    margin: 0 auto;
  }

  .header-navigation {
    &__desktop {
      display: none;
      @include new-ms {
        display: block;
      }
    }
    &__tablet {
      display: block;
      @include new-ms {
        display: none;
      }
    }
  }

  .skip-links {
    &__link {
      left: -999em;
      position: absolute;
      width: 990em;
      z-index: 999;
      &:focus {
        background-color: #fff;
        border: 3px #1c2335 solid;
        color: #000;
        left: 0;
        top: 0;
        padding: 1rem;
        text-decoration: none;
        width: auto;
        z-index: 999;
      }
    }
  }
</style>
